import { contentTypeSchemaApi } from "@platformx/authoring-apis";
import { buildBucketUrl } from "@platformx/utilities";

interface routeListProps {
  title: string;
  icon: string;
  url: string;
  id: string;
  category: string;
  subCategory: string;
  component: string;
  isMenu: boolean;
  isHidden: boolean;
  isHeader: boolean;
  isSideBar: boolean;
  isGallery: boolean;
  hasSearch: boolean;
  listIcon: string;
  menuIcon: string;
  fallbackIcon: string;
  is_shared: boolean;
}

export const fetchRoutes = async () => {
  const routeList: routeListProps[] = [];
  const detailsRes: any = await contentTypeSchemaApi.fetchSchema();
  detailsRes?.authoring_getSchema?.forEach((val) => {
    const isSharedContent = val?.shared_content === true || val?.shared_content === "true";
    const { list_icon = "", menu_icon = "", fallback_icon = "" } = val?.icons || {};
    if (val?.category) {
      return routeList.push(
        {
          title: val?.title,
          icon: buildBucketUrl(`${val?.icon}`),
          url: val?.url,
          id: val?.id,
          category: val?.category,
          subCategory: val?.sub_category,
          component: val?.component,
          isMenu: val?.is_menu,
          isHidden: val?.is_hidden,
          isHeader: val?.is_header,
          isSideBar: val?.is_sideBar,
          isGallery: val?.is_gallery,
          hasSearch: val?.has_search ? val?.has_search : val?.category === "content",
          listIcon: list_icon ? buildBucketUrl(`${list_icon}`) : "",
          menuIcon: menu_icon ? buildBucketUrl(`${menu_icon}`) : "",
          fallbackIcon: fallback_icon ? buildBucketUrl(`${fallback_icon}`) : "",
          is_shared: isSharedContent,
        },
        {
          id: `${val?.category}_update`,
          url: `update/${val?.category?.toLowerCase()}/${val?.sub_category?.toLowerCase()}/:documentId`,
          // url: "/update/:category/:sub_category/:documentId",
          category: val?.category,
          subCategory: val?.sub_category || "",
          isMenu: false,
          icon: "",
          title: val?.sub_category,
          component: "dynamicComponentContainer",
          isHidden: true,
          isSideBar: true,
          isHeader: true,
          isGallery: false,
          hasSearch: false,
          listIcon: "",
          menuIcon: "",
          fallbackIcon: "",
          is_shared: isSharedContent,
        },
      );
    }
  });
  return routeList;
};
